document.addEventListener('DOMContentLoaded', () => {
  const pages = document.querySelectorAll(
    '.site-mega-menu__link[aria-expanded]'
  );

  function toggleAriaExpanded(target) {
    const expanded = target.getAttribute('aria-expanded') === 'true';
    target.setAttribute('aria-expanded', String(!expanded));
    const li = target.closest('li');
    if (!li) return;

    const parent = li.parentElement;
    if (!parent) return;

    [...parent.children].forEach((sibling) => {
      if (sibling !== li && sibling.tagName === 'LI') {
        sibling
          .querySelectorAll('.site-mega-menu__link[aria-expanded]')
          .forEach((a) => a.setAttribute('aria-expanded', 'false'));
      }
    });
  }

  pages.forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      toggleAriaExpanded(el);
    });

    el.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleAriaExpanded(el);
      }
    });
  });
});
